import { ApplicationStatusEnum } from "../../models/enum/application-status.enum";
import { InstrumentTypeEnum } from "../../models/enum/instrument-type.enum";

export const CANCELLED_STATUSES: ApplicationStatusEnum[] = ["APPLICATION_CANCELLED", "CANCELLED", "CANCELLED_WITH_PENDING_PAYMENT", "REJECTED"];

export const INSTRUMENT_TYPE_MAP: Map<InstrumentTypeEnum, string> = new Map([
  ["TRANSFER", "Transfer"],
  ["LEASE", "Lease"],
  ["HDB_MORTGAGE", "HDB Mortgage"],
  ["BANK_MORTGAGE", "Bank Mortgage"],
  ["TDM", "TDM"],
  ["NOD", "NOD"],
  ["TAD", "TAD"],
  ["OTHERS", "Others"],
]);
